import ForgotPasswordForm, { Fields, Submit } from './ForgotPasswordForm'
export * from './ForgotPasswordForm'

export default Object.assign(ForgotPasswordForm, { Fields, Submit })
